var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.13767 21.5363H19.8725C21.4653 21.5363 22.5 20.3393 22.5 18.8885C22.5 18.4624 22.3884 18.0059 22.1449 17.59L14.2623 3.79286C13.7754 2.92038 12.8928 2.46387 12 2.46387C11.1174 2.46387 10.2348 2.92038 9.7377 3.79286L1.84493 17.6103C1.61158 18.0161 1.5 18.4624 1.5 18.8885C1.5 20.3393 2.54492 21.5363 4.13767 21.5363ZM4.14783 20.2987C3.32609 20.2987 2.77827 19.6291 2.77827 18.8885C2.77827 18.6856 2.81884 18.4421 2.94057 18.1885L10.8131 4.38126C11.0667 3.92473 11.5334 3.71168 12 3.71168C12.4768 3.71168 12.9232 3.92473 13.187 4.38126L21.0494 18.1987C21.1711 18.4219 21.232 18.6755 21.232 18.8885C21.232 19.6291 20.6637 20.2987 19.8522 20.2987H4.14783ZM12 14.7798C12.3855 14.7798 12.6189 14.5465 12.6189 14.1204L12.7406 8.69285C12.7507 8.27692 12.4363 7.96242 12 7.96242C11.5536 7.96242 11.2493 8.26678 11.2594 8.69285L11.371 14.1204C11.3812 14.5363 11.6044 14.7798 12 14.7798ZM12 17.9248C12.5174 17.9248 12.9435 17.5088 12.9435 17.0117C12.9435 16.4943 12.5174 16.0885 12 16.0885C11.4928 16.0885 11.0667 16.5045 11.0667 17.0117C11.0667 17.5088 11.4928 17.9248 12 17.9248Z",
    fill: "#EC691A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Warning.1768120cece1596f08c7f768949587df.svg";